<template>
    <div 
        v-if="shown"
        :class="alertClass"
        class="alert is-flashy"
    >
        <div class="alert-icon">
            <font-awesome-icon :icon="icon" class="m-0" />
        </div>
        <div>{{ body }}</div>
    </div>
</template>

<script>
    export default {
        props: {
            icon: {
                required: true,
                type: String,
            },
            type: {
                required: true,
                type: String,
            },
            initialBody: {
                required: false,
                type: String,
                default: '',
            },
        },
        data() {
            return {
                body: '',
                shown: false,
            };
        },
        computed: {
            eventClass() {
                return 'flash_' + this.type;
            },
            alertClass() {
                return 'is-' + this.type;
            },
        },
        created() {
            if (this.initialBody.length > 0) {
                this.body = this.initialBody;
                this.show();
            }

            if (this.initialBody.length < 1) {
                EventBus.$on(
                    this.eventClass, options => this.flash(options)
                );
            }
        },
        methods: {
            show() {
                this.shown = true;
                clearTimeout(this.timeout);

                this.timeout = setTimeout(() => {
                    this.shown = false;
                }, 4000);
            },
            flash(options) {
                this.body = options.message;
                this.show();
            },
        },
    };
</script>